module.exports = __webpack_public_path__ + "static/media/three.b87fc860.svg";